document.addEventListener('DOMContentLoaded', function () {
    const products = document.querySelectorAll('.products__wrapper .product');

    products.forEach(product => {
        const productImageLink = product.querySelector('.product__image');
        const productImage     = productImageLink ? productImageLink.querySelector('img') : null;
        const titleLink        = product.querySelector('.info__title a');
        const colorLinks       = product.querySelectorAll('.info__colors a');

        if (!productImageLink || !productImage || !titleLink || !colorLinks.length) {
            return;
        }

        // Originelen bewaren zodat we kunnen terugzetten bij mouseleave
        productImageLink.dataset.originalHref = productImageLink.href;
        productImage.dataset.originalSrc      = productImage.src;
        titleLink.dataset.originalHref        = titleLink.href;

        colorLinks.forEach(link => {
            // Hover: afbeelding + links aanpassen
            link.addEventListener('mouseenter', () => {
                const imgSrc = link.getAttribute('data-img-src');
                const url    = link.getAttribute('href');

                if (imgSrc) {
                    productImage.src = imgSrc;
                }
                if (url) {
                    productImageLink.href = url;
                    titleLink.href        = url;
                }
            });

            // Hover weg: alles terug naar originele productvariant
            link.addEventListener('mouseleave', () => {
                productImage.src      = productImage.dataset.originalSrc;
                productImageLink.href = productImageLink.dataset.originalHref;
                titleLink.href        = titleLink.dataset.originalHref;
            });

            // Op mobiel klik blokkeren
            link.addEventListener('click', e => {
                if (window.innerWidth < 768) {
                    e.preventDefault();
                }
            });
        });
    });
});
